import { FC, useEffect, useRef, useState } from 'react'
import Script from 'next/script'

interface KlaviyoFormModalProps {
  klaviyoSampleFormCtaText?: string
  klaviyoSampleFormId: string
}

const KlaviyoFormModal: FC<KlaviyoFormModalProps> = ({
  klaviyoSampleFormCtaText,
  klaviyoSampleFormId,
}) => {
  const [isVisible, setIsVisible] = useState(false)
  const ref = useRef(null)

  const handleClickOutside = (event: MouseEvent) => {
    if (ref.current && !ref.current.contains(event.target)) {
      setIsVisible(false)
    }
  }
  const handleKeyDown = (event: KeyboardEvent) => {
    if (event.key === 'Escape') {
      setIsVisible(false)
    }
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside)
    document.addEventListener('keydown', handleKeyDown)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
      document.removeEventListener('keydown', handleKeyDown)
    }
  }, [])

  useEffect(() => {
    if (typeof window !== 'undefined' && isVisible) {
      try {
        window._klOnsite = window._klOnsite || []
        window._klOnsite.push(['openForm', klaviyoSampleFormId])
      } catch (error) {
        console.error('Failed to initialize Klaviyo form:', error)
        setIsVisible(false)
      }
    }
  }, [isVisible, klaviyoSampleFormId])

  return (
    <>
      <Script
        async
        type="text/javascript"
        src={`https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=${process.env.NEXT_PUBLIC_KLAVIYO_COMPANY_ID}`}
      ></Script>
      <div
        sx={{ textDecoration: 'underline', cursor: 'pointer' }}
        onClick={() => setIsVisible(!isVisible)}
        role="button"
        aria-haspopup="dialog"
        aria-expanded
      >
        {klaviyoSampleFormCtaText || 'Get FREE Sample Report'}
      </div>
      {isVisible && (
        <div
          ref={ref}
          role="dialog"
          aria-modal="true"
          className={`klaviyo-form-${klaviyoSampleFormId}`}
        ></div>
      )}
    </>
  )
}

export default KlaviyoFormModal
